import { render, staticRenderFns } from "./FE_settings.vue?vue&type=template&id=a220c328&scoped=true"
import script from "./FE_settings.vue?vue&type=script&lang=js"
export * from "./FE_settings.vue?vue&type=script&lang=js"
import style0 from "./FE_settings.vue?vue&type=style&index=0&id=a220c328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a220c328",
  null
  
)

export default component.exports